import { fillMissingLocalizedCategoriesNames } from "@robe/core-api/subCategory/utils";
import { Content, SubCategory } from "@robe/core-types";

export const resolveContentSubCategories = <T extends Content>(content: T) => ({
  ...content,
  subCategories: content.subCategories
    ? Object.fromEntries(
      Object.entries(content.subCategories).map(([key, value]) => {
        if (value) {
          return [key, fillMissingLocalizedCategoriesNames(value as SubCategory[])];
        }

        return [key, value];
      })
    )
    : content.subCategories,
});

export const resolveContentsSubCategories = (contents: Content[]): Content[] => contents.map(resolveContentSubCategories);
